import {
  SPOOF_STARTED,
  SPOOF_STOPPED,
  SPOOF_ERRORED
} from "constants/spoofing";

export default function spoofing(state = "", { type, payload }) {
  switch (type) {
    case SPOOF_STARTED:
      return payload;
    case SPOOF_STOPPED:
    case SPOOF_ERRORED:
      return "";
    default:
      return state;
  }
}
